module.exports = __webpack_public_path__ + "img/widgetcatalog-3.c3f42ba1.jpg";